/*Cookie*/
(function () {
    window.app = window.app || {};

    var domain = location.hostname.replace(/^(www|m)/i, '');

    var expires_time_mode = {
        day: 1,
        hour: 2,
        minute: 3,
        second: 4
    };

    function extend() {
        var i = 0;
        var result = {};
        for (; i < arguments.length; i++) {
            var attributes = arguments[i];
            for (var key in attributes) {
                result[key] = attributes[key];
            }
        }
        return result;
    }

    function parseQueryStringValue(value) {
        if (!value) return {};
        var result = {},
            array = value.split('&');
        for (var i = 0, l = array.length; i < l; i++) {
            var setting = array[i].split('=');
            result[setting[0]] = setting[1];
        }
        return result;
    }

    function set(key, value, attributes, withoutdomain) {
        var result;
        if (typeof document === 'undefined') {
            return;
        }

        var attributes = extend({
            path: '/',
            domain: domain
        }, attributes);

        if (withoutdomain) {
            attributes.domain = null;
        }

        if (typeof attributes.expires === 'number') {
            var expires = new Date();
            if (attributes.expires_time_mode === expires_time_mode.hour) {
                expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5 / 24);
            } else if (attributes.expires_time_mode === expires_time_mode.minute) {
                expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5 / 24 / 60);
            } else if (attributes.expires_time_mode === expires_time_mode.second) {
                expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5 / 24 / 60 / 60);
            } else {
                expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
            }
            attributes.expires = expires;
        }

        if (window.JSON && window.JSON.stringify) {
            result = JSON.stringify(value);
            if (/^[\{\[]/.test(result)) {
                value = result;
            }
        }

        value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
        key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);

        var stringifiedAttributes = '';

        for (var attributeName in attributes) {
            if (!attributes[attributeName]) {
                continue;
            }
            stringifiedAttributes += '; ' + attributeName;
            if (attributes[attributeName] === true) {
                continue;
            }
            stringifiedAttributes += '=' + attributes[attributeName];
        }
        return (document.cookie = key + '=' + value + stringifiedAttributes);
    }

    function get(key) {
        if (!key) {
            result = {};
        }

        var result;

        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var rdecode = /(%[0-9A-Z]{2})+/g;
        var i = 0;

        for (; i < cookies.length; i++) {
            var parts = cookies[i].split('=');
            var cookie = parts.slice(1).join('=');

            try {
                var name = parts[0].replace(rdecode, decodeURIComponent);
                cookie = cookie.replace(rdecode, decodeURIComponent);

                if (key === name) {
                    result = cookie;
                    break;
                }

                if (!key) {
                    result[name] = cookie;
                }
            } catch (e) { }
        }

        return (result === undefined ? null : result);
    }

    cookie = {

        expires_time_mode: expires_time_mode,

        set: function (key, value, attributes) {
            set(key, 0, { expires: -1 }, true);
            return set(key, value, attributes);
        },

        get: get,

        remove: function (key) {
            return cookie.set(key, 0, { expires: -1 });
        },

        getParsedQueryStringValue: function (key) {
            var value = get(key, false);
            return parseQueryStringValue(value);
        },

        getParsedJsonValue: function (key) {
            var result;

            if (window.JSON && window.JSON.parse) {

                try {
                    var value = get(key, true);

                    if (value.charAt(0) === '"') {
                        value = value.slice(1, -1);
                    }

                    result = JSON.parse(value);
                } catch (e) {
                }
            }

            return result;
        },

        NamedCookie: function (cookieName, cookieContext) {
            this._cookieName = cookieName;
            this._cookieContext = cookieContext || cookie;
        },

        getUserLanguage: function () {
            return cookie.get('ul') || 'en';
        },
        setUserLanguage: function (language) {
            cookie.set('ul', language, { expires: 365 });
        },

        getShowPromotion: function () {
            return cookie.getParsedJsonValue('show_promotion');
        },
        setShowPromotion: function (show, img) {
            var data = {
                show: !!show,
                img: img
            };
            app.cookie.set('show_promotion', data, { expires: 365 });
            return data
        },

        getRegistred: function () {
            return cookie.getParsedJsonValue('r');
        },
        setRegistred: function (value) {
            return cookie.getParsedJsonValue('r', value);
        },

        setUseFullWebSite: function (value) {
            return cookie.set('UseFullWebSite', value, { expires: 365 });
        },
        getUseFullWebSite: function () {
            return cookie.get('UseFullWebSite');
        },

        setSalePos: function (saleID, value) {
            cookie.set(saleID, value, { expires: 10, expires_time_mode: expires_time_mode.second });
        },

        setFirstLogin: function () {
            cookie.set('ApacFirstLogin', '1', { expires: 1, expires_time_mode: expires_time_mode.hour });
        },

        getUserSettings: function (setting) {
            var settings = cookie.getParsedQueryStringValue('us');
            return setting ? settings[setting] : settings;
        }
    };

    cookie.NamedCookie.prototype.save = function (data, ttl) {
        return this._cookieContext.set(this._cookieName, data, { expires: ttl, expires_time_mode: expires_time_mode.second });
    };

    cookie.NamedCookie.prototype.get = function () {
        return this._cookieContext.get(this._cookieName);
    };

    cookie.NamedCookie.prototype.remove = function () {
        return this._cookieContext.set(this._cookieName, 0, { expires: -1 });
    };

    window.app.cookie = cookie;
})();